<template>
  <div class="mentIndex">
    <div class="home_con_index">
      <div style="width:306px"></div>
      <div class="mentCon">
        <div class="ment_title">充电设备信息</div>
        <p>1.充电设备信息（EquipmentInfo）</p>
        <img src="@/assets/ment/cc.png" alt="" />
        <p>2.充电设备接口信息（ConnectorInfo）</p>
         <img src="@/assets/ment/dd.png" alt="" />
          <p>3. 充电设备接口状态（ConnectorStatusInfo）</p>
         <img src="@/assets/ment/ee.png" alt="" />
          <p>4.充电站状态信息（StationStatusInfo）</p>
         <img src="@/assets/ment/ff.png" alt="" />
       
      </div>
    </div>
  </div>
</template>


<script>
import Ment from "@/components/ment";
export default {
  components: {
    Ment,
  },
};
</script>

<style scoped>

.home_con_index {
  display: flex;
  text-align: left;
 
}
.mentCon small {
  margin: 23px 0px 12px 0px;
  font-size: 12px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #5a6073;
  line-height: 12px;
}
.mentCon img {
  margin: 0px;
}
</style>


// WEBPACK FOOTER //
// src/page/document/documentd.vue